module.exports = __webpack_public_path__ + "static/media/livechatHero2x.824e329e.png";